import { useIdleTimer } from 'react-idle-timer';

import { SESSION_TIMEOUT_CONFIG } from '../../constants/sessionTimeout';

interface IUseSessionTimeoutProps {
  onTimeout: () => void;
  onWarning: () => void;
  onActive: () => void;
  timeoutMinutes?: number;
  warningMinutes?: number;
  isEnabled?: boolean;
}

interface IUseSessionTimeoutReturn {
  isIdle: boolean;
  timeLeft: number;
  reset: () => void;
}

const useSessionTimeout = ({
  onTimeout,
  onWarning,
  onActive,
  timeoutMinutes = SESSION_TIMEOUT_CONFIG.DEFAULT_TIMEOUT_MINUTES,
  warningMinutes = SESSION_TIMEOUT_CONFIG.DEFAULT_WARNING_MINUTES,
  isEnabled = true,
}: IUseSessionTimeoutProps): IUseSessionTimeoutReturn => {
  const timeoutTimer = useIdleTimer({
    timeout: timeoutMinutes * 60 * 1000,
    onIdle: isEnabled ? onTimeout : undefined,
    throttle: SESSION_TIMEOUT_CONFIG.THROTTLE_MS,
    events: [...SESSION_TIMEOUT_CONFIG.MONITORED_EVENTS],
    onActive,
    startOnMount: true,
    stopOnIdle: false,
  });

  const warningTimer = useIdleTimer({
    timeout: warningMinutes * 60 * 1000,
    onIdle: isEnabled ? onWarning : undefined,
    throttle: SESSION_TIMEOUT_CONFIG.THROTTLE_MS,
    events: [...SESSION_TIMEOUT_CONFIG.MONITORED_EVENTS],
    onActive,
    startOnMount: true,
    stopOnIdle: false,
  });

  const { isIdle: isTimeoutIdle, reset: resetTimeout, getRemainingTime } = timeoutTimer;
  const { isIdle: isWarningIdle, reset: resetWarning } = warningTimer;

  return {
    isIdle: Boolean(isTimeoutIdle) || Boolean(isWarningIdle),
    reset: () => {
      resetTimeout();
      resetWarning();
    },
    timeLeft: getRemainingTime(),
  };
};

export default useSessionTimeout;
